import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionRouterView = _resolveComponent("TransitionRouterView")!
  const _component_BottomBar = _resolveComponent("BottomBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TransitionRouterView),
    _createVNode(_component_BottomBar)
  ], 64))
}